
window.toggleNav = function () {
  var nav = document.getElementById('mobile-nav');
  nav.classList.toggle("hidden")
}